import { render } from "./Menu.vue?vue&type=template&id=154637c2&scoped=true&bindings={}"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=154637c2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-154637c2"

export default script